import React, { lazy, Suspense, useEffect, useState } from 'react'
import COASidebarComponent from './COASidebarComponent'
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie"
import { getCOALedgerMasterDetail, getCOASidebar } from '../../../Redux/action/Account/ChartOfAccountAction';
import { useSearchParams } from 'react-router-dom';
const COALedgerMasterDetailComponent = lazy(() =>
    import("./COALedgerMasterDetailComponent")
);

const COA = () => {
    const token = Cookies.get("token");
    const user_id = Cookies.get("flexichain_user_id");
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const ledger_master_id = searchParams.get("ledger_master_id");
    let [ledgerGroupMasterDetails, setLedgerGroupMasterDetails] = useState(null);

    useEffect(() => {
        if (ledger_master_id) {
            try {
                let lm_id = atob(ledger_master_id);
                if (lm_id) {
                    dispatch(getCOASidebar(user_id, token, lm_id));
                    dispatch(getCOALedgerMasterDetail(user_id, token, lm_id));
                } else {
                    dispatch(getCOASidebar(user_id, token));
                }
            } catch (error) {
                console.log(error);
                dispatch(getCOASidebar(user_id, token));
            }
        } else {
            dispatch(getCOASidebar(user_id, token));
        }
    }, [ledger_master_id]);

    const {
        loadingCOASidebar,
        COASidebar,
        COASidebarError,

        loadingCOALedgerMasterDetail,
        COALedgerMasterDetail,
        COALedgerMasterDetailError,
    } = useSelector(state => state.ChartOfAccountReducer);

    useEffect(() => {
        if (ledger_master_id) {
            setLedgerGroupMasterDetails(COALedgerMasterDetail);
        } else {
            setLedgerGroupMasterDetails(null);
        }
    }, [COALedgerMasterDetail, ledger_master_id])

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-4">
                            <COASidebarComponent data={COASidebar} />
                        </div>
                        <div className="col-md-8">
                            <Suspense fallback={<div>Loading...</div>}>
                                <COALedgerMasterDetailComponent
                                    data={ledgerGroupMasterDetails}
                                />
                            </Suspense>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default COA